import React from 'react';
import { motion } from 'framer-motion';
import { EyeSlashIcon, PuzzlePieceIcon, ClockIcon, QuestionMarkCircleIcon } from '@heroicons/react/24/outline';

const InvSlide02Problem: React.FC = () => {
  const problems = [
    {
      icon: EyeSlashIcon,
      title: 'Zero Visibility',
      description: 'Report cards vary school to school. Parents wait 2 years between NAPLAN tests to know where their kids truly stand.',
      color: '#ef4444',
    },
    {
      icon: PuzzlePieceIcon,
      title: 'Fragmented Systems',
      description: 'Google Classroom, random docs, cloned sheets that can\'t be resubmitted. As a parent, I can\'t follow homework or deadlines.',
      color: '#f59e0b',
    },
    {
      icon: ClockIcon,
      title: 'Wasted Time',
      description: 'Kids doing hours of homework on concepts they already understand, while struggling areas go untargeted.',
      color: '#8b5cf6',
    },
    {
      icon: QuestionMarkCircleIcon,
      title: 'Unknown Curriculum',
      description: 'What should a Year 5 student know? Parents have no visibility into the syllabus or expected outcomes.',
      color: '#0ea5e9',
    },
  ];

  return (
    <div className="flex flex-col items-center justify-center h-full px-16">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center mb-12"
      >
        <h2 className="text-5xl font-bold text-white mb-4">
          The Problem: A Parent's Frustration
        </h2>
        <p className="text-2xl text-[#94a3b8] max-w-4xl">
          "I have young kids in Year 3 and Year 5. Other than report cards, I have no idea where my kids are truly at."
        </p>
      </motion.div>

      <div className="grid grid-cols-2 gap-8 max-w-5xl">
        {problems.map((item, index) => (
          <motion.div
            key={item.title}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 + index * 0.1 }}
            className="flex gap-5 p-6 rounded-xl"
            style={{
              background: `${item.color}10`,
              border: `1px solid ${item.color}30`,
            }}
          >
            <div
              className="w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0"
              style={{
                background: `${item.color}20`,
                border: `2px solid ${item.color}50`,
              }}
            >
              <item.icon className="w-7 h-7" style={{ color: item.color }} />
            </div>
            <div>
              <h3 className="text-xl font-semibold text-white mb-2">{item.title}</h3>
              <p className="text-[#94a3b8] leading-relaxed">{item.description}</p>
            </div>
          </motion.div>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8 }}
        className="mt-10 text-center"
      >
        <p className="text-xl text-[#64748b] italic">
          "Life is getting ever more complex and parents have no overview of where their kids are at."
        </p>
      </motion.div>
    </div>
  );
};

export default InvSlide02Problem;
